import { render } from "./WorkAccidentM.vue?vue&type=template&id=b9312d18&scoped=true"
import script from "./WorkAccidentM.vue?vue&type=script&lang=js"
export * from "./WorkAccidentM.vue?vue&type=script&lang=js"

import "./WorkAccidentM.vue?vue&type=style&index=0&id=b9312d18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9312d18"]])

export default __exports__